import * as tslib_1 from "tslib";
import React from 'react';
import Waypoint from 'react-waypoint';
import { BiDataHook } from '../../biLogger';
import TorpedoContentStrip from './ContentStrip';
import TorpedoRelatedItem from './RelatedItem';
import s from '../Torpedo.scss';
import HiddenRow from './HiddenRow';
var TorpedoStrip = function (props) {
    var onOffsetReached = props.onOffsetReached, strip = props.strip, renderItem = props.renderItem, onNearHidden = props.onNearHidden;
    var stripContent = !isStripRendered(strip, props) ? (React.createElement(HiddenRow, { key: "row-hidden-" + strip.idx, strip: strip, onNearHidden: onNearHidden })) : (React.createElement("div", { key: "row-" + strip.idx, className: s['strip'], style: {
            width: strip.width,
        }, "data-hook": BiDataHook.CONTENT_ROW_IDX + "-" + strip.idx }, strip.groups.map(function (group) { return group.items.map(renderItem); })));
    var content = (React.createElement("div", { key: "row-" + strip.idx },
        stripContent,
        React.createElement(TorpedoContentStrip, tslib_1.__assign({ strip: strip }, props)),
        React.createElement(TorpedoRelatedItem, tslib_1.__assign({ strip: strip }, props))));
    if (onOffsetReached) {
        var cb = function () {
            onOffsetReached && onOffsetReached(strip.groups[0].idx);
        };
        return (React.createElement(Waypoint, { fireOnRapidScroll: false, bottomOffset: '90%', key: strip.groups[0].idx, onEnter: cb }, content));
    }
    else {
        return content;
    }
};
TorpedoStrip.displayName = 'TorpedoStrip';
function isStripRendered(strip, props) {
    if (!props.enableScrollVisibilityOptimisation) {
        return true;
    }
    if (!strip.groups || strip.groups.length === 0 || !strip.groups[0]) {
        return true;
    }
    if (!strip.groups[0].items || !strip.groups[0].items[0]) {
        return true;
    }
    return strip.groups[0].items[0].visibility.rendered === true;
}
export default TorpedoStrip;
//# sourceMappingURL=Strip.js.map